import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import lazyLoad from '@helper/lazy-load'
import ErrorBoundary from '@components/error-boundary'

const router = [
    {
        path: '/app/manage',
        hasErrorBoundary: true,
        ErrorBoundary,
        element: lazyLoad(() => import('@pages/manage/components/main')),
        loader: () => ({ menuIndex: 6, key: 'manage.manage', icon: 'icon-system', show: true }),
        children: [
            {
                index: true,
                element: <Navigate to="/app/manage/shop"/>
            },
            {
                path: '/app/manage/shop',
                element: lazyLoad(() => import('@pages/manage-shop/components/main')),
                loader: () => ({
                    menuIndex: 1,
                    key: 'manage.shop',
                    // icon: 'icon-kefu',
                    activeMenu: '/app/manage/shop',
                    show: true
                })
            },
            {
                path: '/app/manage/group',
                element: lazyLoad(() => import('@pages/manage-group/components/main')),
                loader: () => ({
                    menuIndex: 3,
                    key: 'manage.group',
                    // icon: 'icon-kefu',
                    activeMenu: '/app/manage/group',
                    show: true
                })
            },
            {
                path: '/app/manage/user',
                element: lazyLoad(() => import('@pages/manage-user/components/main')),
                loader: () => ({
                    menuIndex: 2,
                    key: 'manage.user',
                    // icon: 'icon-kefu',
                    activeMenu: '/app/manage/user',
                    show: true
                })
            },
            {
                path: '/app/manage/role',
                element: lazyLoad(() => import('@pages/manage-role/components/main')),
                loader: () => ({
                    menuIndex: 4,
                    key: 'manage.role',
                    // icon: 'icon-kefu',
                    activeMenu: '/app/manage/role',
                    show: true
                })
            },
            {
                path: '/app/manage/log',
                element: <Outlet />,
                loader: () => ({ menuIndex: 5, key: 'manage.log.log', show: true }),
                children: [
                    {
                        index: true,
                        element: <Navigate to="/app/manage/log/action" />
                    },
                    {
                        path: '/app/manage/log/action',
                        element: lazyLoad(() => import('@pages/manage-log-action/components/main')),
                        loader: () => ({ menuIndex: 1, key: 'manage.log.action', activeMenu: '/app/manage/log/action', show: true })
                    },
                    {
                        path: '/app/manage/log/export',
                        element: lazyLoad(() => import('@pages/manage-log-export/components/main')),
                        loader: () => ({ menuIndex: 2, key: 'manage.log.export', activeMenu: '/app/manage/log/export', show: true })
                    },
                    {
                        path: '/app/manage/log/import',
                        element: lazyLoad(() => import('@pages/manage-log-import/components/main')),
                        loader: () => ({ menuIndex: 3, key: 'manage.log.import', activeMenu: '/app/manage/log/import', show: true })
                    }
                ]
            }
        ]
    }
]

export default router
